import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const LABEL = { crm_and_mailcoach: "CRM + Mailcoach", mailcoach_only: "Mailcoach only", crm_only: "CRM only", other: "Other" };

const Row = ({ k, v }) => <div className="flex justify-between gap-3 text-xs"><span className="text-slate-500">{k}</span><b className="text-slate-800">{Number(v).toLocaleString()}</b></div>;

export const EligibilityEvidence = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/email-marketing/eligibility/evidence").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const n = d.counts || {};
  return (
    <section className="bg-white border border-slate-200 rounded-xl p-4 grid gap-4 sm:grid-cols-3" data-testid="elig-evidence">
      <div className="space-y-1"><p className="text-xs font-semibold text-slate-700">Evidence found</p>
        <Row k="Subscribers reviewed" v={d.total} /><Row k="Mailcoach consent text or IP recorded" v={n.mc_consent_text_or_ip || 0} />
        <Row k="Mailcoach date = bulk import day (2 Mar 2026)" v={n.mc_date_is_bulk_import_day || 0} />
        <Row k="TedOps consent records" v={n.tedops_consent_record || 0} /><Row k="With WooCommerce purchases" v={n.with_purchases || 0} />
        <Row k="Ambiguous Mailcoach matches (held)" v={n.ambiguous || 0} /><Row k="Reviewed by an admin" v={n.decided || 0} /></div>
      <div className="space-y-1"><p className="text-xs font-semibold text-slate-700">By source</p>
        {Object.entries(d.source || {}).map(([k, v]) => <Row key={k} k={LABEL[k] || k} v={v} />)}</div>
      <div className="space-y-1"><p className="text-xs font-semibold text-slate-700">Mailcoach subscribed year</p>
        {Object.entries(d.mc_year || {}).map(([k, v]) => <Row key={k} k={k} v={v} />)}</div>
    </section>
  );
};
